import { render, staticRenderFns } from "./CataItem.vue?vue&type=template&id=5e500d0f&scoped=true&"
import script from "./CataItem.vue?vue&type=script&lang=js&"
export * from "./CataItem.vue?vue&type=script&lang=js&"
import style0 from "./CataItem.vue?vue&type=style&index=0&id=5e500d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e500d0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VImg})
